<ng-container *ngFor="let part of parts">
  <b *ngIf="isBold(part)">{{getBoldPart(part)}}</b>
  <ng-container *ngIf="!isBold(part)">{{part}}</ng-container>
</ng-container>
